import { inject } from 'mobx-react';

//components
import withLocalization from '~/hoc/withLocalization';
import ClientApiSettings from '../../Clients/ClientApiSettings';

const ApiGatewayIntegration = (props) => {
    const { commonStore } = props;
    const clientId = commonStore?.config?.client?.id;
    return (
        <div className='mt-3 w-75'>
            <ClientApiSettings clientId={clientId} />
        </div>
    )
}

export default inject('commonStore')(withLocalization(ApiGatewayIntegration));